import { render } from "./IconSort.vue?vue&type=template&id=541afe4a&scoped=true"
const script = {}

import "./IconSort.vue?vue&type=style&index=0&id=541afe4a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-541afe4a"]])

export default __exports__